// components/TrainingContainer.jsx
import React, { Component } from "react";
import { Spinner } from "@blueprintjs/core";
import { withRouterParams } from "../../utils/withRouterParams";
import { BASE_API } from "../../utils/constants";
import Training from "./Training";

class TrainingContainer extends Component {
    state = {
        loadingTeam: true,
        loadingPlayers: false,
        error: null,
        team: null
    };

    componentDidMount() {
        /* ▶ 1. extragem slug-ul în mod robust */
        const search = this.props.location?.search || window.location.search;
        const urlParams = new URLSearchParams(search);
        const teamSlug = urlParams.get("echipa");   // ← din ?echipa=<slug>

        if (!teamSlug) {
            this.setState({ error: "Parametrul ?echipa lipsește", loadingTeam: false });
            return;
        }
        this.fetchTeamBySlug(teamSlug);
    }

    /* slug -> id + name */
    async fetchTeamBySlug(slug) {
        try {
            const res = await fetch(`${BASE_API}/api/team-by-slug/${slug}`);
            const json = await res.json();
            if (!res.ok) throw new Error(json.error || "Eroare team-by-slug");

            this.setState({ team: json.team, loadingTeam: false }, () =>
                this.fetchPlayers(json.team.id)
            );
        } catch (err) {
            this.setState({ error: err.message, loadingTeam: false });
        }
    }

    /* players */
    async fetchPlayers(teamId) {
        try {
            this.setState({ loadingPlayers: true });
            const res = await fetch(`${BASE_API}/api/team-players/${teamId}`);
            const json = await res.json();
            if (!res.ok) throw new Error(json.error || "Eroare team-players");

            this.setState(prev => ({
                team: { ...prev.team, players: json.players ?? [] },
                loadingPlayers: false
            }));
        } catch (err) {
            this.setState({ error: err.message, loadingPlayers: false });
        }
    }

    render() {
        const { loadingTeam, loadingPlayers, error, team } = this.state;

        if (loadingTeam || loadingPlayers) return <Spinner />;
        if (error) return <p className="bp5-text-danger">{error}</p>;
        if (!team) return null;

        return (
            <Training
                teamId={team.id}
                teamName={team.name}
                players={team.players}   // îi poți ignora în Training dacă faci fetch acolo
            />
        );
    }
}

export default withRouterParams(TrainingContainer);
